import { initialiseModule as initialiseModuleAuth } from "./auth";
import { initialiseModule as initialiseModuleEmails } from "./emails";
import { initialiseModule as initialiseModuleFeed } from "./feed";
import { initialiseModule as initialiseModuleTrainingCollection } from "./trainingCollections";
import { initialiseModule as initialiseModuleWorkout } from "./workouts";
import { initialiseModule as initialiseModuleUsers } from "./users";
import { initialiseModule as initialiseModuleSettings } from "./settings";
import { initialiseModule as initialiseModuleOrganizations } from "./organizations";
import { initialiseModule as initialiseModuleTeams } from "./teams";
import { initialiseModule as initialiseModuleProfile } from "./profile";
import { initialiseModule as initialiseModuleChats } from "./chats";
import { initialiseModule as initialiseModuleChat } from "./chat";
import { initialiseModule as initialiseModulePayments } from "./payments";
import { initialiseModule as initialiseModuleStats } from "./stats";
import { initialiseModule as initialiseModuleOrganizationPaymentSettings } from "./organizationPaymentSettings";
import { initialiseModule as initialiseModuleSubscriptions } from "./offerings";
import { initialiseModule as initialiseModuleBenefits } from "./benefits";
import { initialiseModule as initialiseModuleBookings } from "./bookings";
import { initialiseModule as initialiseModuleSchedule } from "./schedule";
import { initialiseModule as initialiseModuleBookedSessions } from "./booked-sessions";
import { initialiseModule as initialiseModuleOrganizationSettings } from "./organizationSettings";
import { initialiseModule as initialiseModuleNetworkAdmin } from "./networkAdmin";
import type { ModuleOptions } from "@/types";

export const initialiseModules: (options: ModuleOptions) => void = (opts) => {
  initialiseModuleAuth(opts);
  initialiseModuleEmails(opts);
  initialiseModuleFeed(opts);
  initialiseModuleChat(opts);
  initialiseModuleTrainingCollection(opts);
  initialiseModuleWorkout(opts);
  initialiseModuleUsers(opts);
  initialiseModuleSettings(opts);
  initialiseModuleOrganizations(opts);
  initialiseModuleOrganizationSettings(opts);
  initialiseModuleTeams(opts);
  initialiseModuleProfile(opts);
  initialiseModuleChats(opts);
  initialiseModulePayments(opts);
  initialiseModuleStats(opts);
  initialiseModuleOrganizationPaymentSettings(opts);
  initialiseModuleSubscriptions(opts);
  initialiseModuleBenefits(opts);
  initialiseModuleBookings(opts);
  initialiseModuleSchedule(opts);
  initialiseModuleBookedSessions(opts);
  initialiseModuleNetworkAdmin(opts);
};
